import React, {lazy, Suspense} from 'react';
const TheWeek = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./TheWeek'));

const Week = (props) => {

    return <Suspense fallback={null}>
        <TheWeek {...props} />
    </Suspense>
}

export default Week;